import { ReactElement } from "react";

export class MenuItem {
  id: number;
  name: string;
  summary: string;
  icon: ReactElement;
  onClickLink?: string;

  constructor(
    id: number,
    name: string,
    summary: string,
    icon: ReactElement,
    onClickLink?: string,
  ) {
    this.id = id;
    this.name = name;
    this.summary = summary;
    this.icon = icon;
    this.onClickLink = onClickLink;
  }
}
